// export const URL_BASE = "http://localhost:5600";
// export const URL_BASE = "https://sandbox.assinauai.com.br";
export const URL_BASE = "https://production.assinauai.com.br";